import { isPossiblePhoneNumber, parsePhoneNumber } from 'react-phone-number-input';

export const safePhoneNumber = (phoneNumber: string): string => {
  if (phoneNumber.startsWith('+') && isPossiblePhoneNumber(phoneNumber)) {
    const parsedPhone = parsePhoneNumber(phoneNumber);

    if (['US', 'CA'].includes(parsedPhone?.country ?? '')) {
      return parsedPhone?.nationalNumber || phoneNumber;
    }
  }

  return phoneNumber;
};

export const safeParsePhoneNumber = (phoneNumber: string): string => {
  if (!phoneNumber.startsWith('+') && isPossiblePhoneNumber(`+1${phoneNumber}`)) {
    return `+1${phoneNumber}`;
  }

  return phoneNumber;
};
